// Vendor libraries
import { EventEmitter } from '@angular/core';
// Interfaces / Types / Enums
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
// Components
import { PreviewImageModalComponent } from 'NewAngular/features/components/modals/preview-image-modal/preview-image-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
import * as i3 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i4 from "@angular/common";
import * as i5 from "../modal-base/components/modal-base.component";
import * as i6 from "../modal-base/components/simple-modal-footer.component";
import * as i7 from "../modal-base/components/simple-modal-header.component";
import * as i8 from "../preview-image-modal/preview-image-modal.component";
import * as i9 from "../../../directives/icon/icon.directive";
const _c0 = a0 => ({ active: a0 });
function TemplateModalComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13);
    i0.ɵɵlistener("click", function TemplateModalComponent_li_6_Template_li_click_0_listener() { const indexOfElement_r2 = i0.ɵɵrestoreView(_r1).index; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateCurrentCategoryIndex(indexOfElement_r2)); });
    i0.ɵɵelement(1, "a", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r4 = ctx.$implicit;
    const indexOfElement_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-test-id", "data-template-category-" + indexOfElement_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r2.currentCategoryIndex === indexOfElement_r2))("textContent", category_r4.name);
} }
function TemplateModalComponent_div_11_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵlistener("click", function TemplateModalComponent_div_11_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const template_r8 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.previewImageHandler(template_r8.preview_image_url)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-preview");
} }
function TemplateModalComponent_div_11_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const template_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Benchmark: ", template_r8.benchmark.security_name, " ");
} }
function TemplateModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "label", 16)(2, "input", 17);
    i0.ɵɵlistener("change", function TemplateModalComponent_div_11_Template_input_change_2_listener() { const indexOfElement_r6 = i0.ɵɵrestoreView(_r5).index; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.currentTemplateIndex = indexOfElement_r6); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 18)(4, "span", 19);
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵtemplate(6, TemplateModalComponent_div_11_div_6_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 22);
    i0.ɵɵelement(8, "div", 23);
    i0.ɵɵtemplate(9, TemplateModalComponent_div_11_div_9_Template, 2, 1, "div", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "div", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const template_r8 = ctx.$implicit;
    const indexOfElement_r6 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r2.currentTemplateIndex === indexOfElement_r6)("value", indexOfElement_r6);
    i0.ɵɵattribute("data-test-id", "data-template-" + indexOfElement_r6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", template_r8.preview_image_url);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", template_r8.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.templateType === "model_portfolio");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", template_r8.description);
} }
export class TemplateModalComponent {
    constructor(ajaxService, urlsService, customPDFReportService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.customPDFReportService = customPDFReportService;
        this.templateSelectionHandler = new EventEmitter();
        this.modalOpen = false;
        this.currentCategoryIndex = 0;
        this.currentCategoryTemplates = [];
        this.currentTemplateIndex = null;
        this.templatesByCategory = [];
        this.templateHeader = '';
        this.titlePrefix = '';
        this.templateType = '';
        this.eventType = '';
        this.hasTemplates = false;
    }
    ngOnInit() {
        // Avoid displaying data and errors when user is not logged in
        if (!window.USER.authenticated) {
            return;
        }
        switch (this.itemType) {
            case SavedItemType.MODEL_PORTFOLIO:
                this.titlePrefix = 'Model Portfolio ';
                this.templateType = 'model_portfolio';
                this.eventType = 'started_model_portfolio_from_template';
                break;
            case SavedItemType.SCATTER_PLOT:
                this.titlePrefix = 'Scatter Plot ';
                this.templateType = 'scatter_plot';
                this.eventType = 'started_scatter_plot_from_template';
                break;
            case SavedItemType.FUND_CHART:
                this.titlePrefix = 'Fundamental Chart ';
                this.templateType = 'fundamental_chart';
                this.eventType = 'started_fundamental_chart_from_template';
                break;
            case SavedItemType.FUND_SCREEN:
                this.titlePrefix = 'Fund Screener';
                this.templateType = 'fund_screener';
                this.eventType = 'started_fund_screener_from_template';
                break;
            case SavedItemType.STOCK_SCREEN:
                this.titlePrefix = 'Stock Screener';
                this.templateType = 'company_screener';
                this.eventType = 'started_company_screener_from_template';
                break;
            case SavedItemType.COMP_TABLE:
                this.titlePrefix = 'Comparison Table ';
                this.templateType = 'comp_table';
                this.eventType = 'started_comparison_table_from_template';
                break;
            case SavedItemType.TIMESERIES_TABLE:
                this.titlePrefix = 'Timeseries Table';
                this.templateType = 'timeseries_table';
                this.eventType = 'started_timeseries_table_from_template';
                break;
            case SavedItemType.CUSTOM_PDF_REPORT:
                this.titlePrefix = 'Custom PDF Report';
                this.templateType = 'custom_pdf_report';
                this.eventType = 'started_custom_pdf_report_from_template';
                break;
            case SavedItemType.USER_TALKING_POINT:
                this.titlePrefix = 'Talking Point';
                this.templateType = 'user_talking_point';
                this.eventType = 'started_talking_point_from_template';
                break;
            case SavedItemType.HYPOTHETICAL:
                this.titlePrefix = 'Scenario';
                this.templateType = 'hypothetical';
                this.eventType = 'started_scenario_from_template';
                break;
            case SavedItemType.TECH_CHART:
                this.titlePrefix = 'Technical Chart ';
                this.templateType = 'technical_chart';
                this.eventType = 'started_technical_chart_from_template';
                break;
            // no default
        }
        this.templateHeader = `${this.titlePrefix} Templates`;
        if (this.itemType === SavedItemType.CUSTOM_PDF_REPORT) {
            this.customPDFReportService.getPDFReportTemplates().subscribe((data) => {
                this.templatesByCategory = data;
                this.currentCategoryTemplates = this.getCurrentCategoryTemplates();
                this.hasTemplates = this.templatesByCategory.some((category) => category?.templates?.length);
            });
        }
        else {
            this.getTemplatesByCategory().subscribe((data) => {
                this.templatesByCategory = data;
                this.currentCategoryTemplates = this.getCurrentCategoryTemplates();
                this.hasTemplates = this.templatesByCategory.some((category) => category.templates && category.templates.length > 0);
            });
        }
    }
    getTemplatesByCategory() {
        const urlParams = { templateType: this.templateType };
        const url = this.urlsService.getUrl(this.urlsService.DATA_TEMPLATES.DATA_TEMPLATE_LIBRARY, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    updateCurrentCategoryIndex(index) {
        this.currentCategoryIndex = index;
        this.currentCategoryTemplates = this.getCurrentCategoryTemplates();
        this.currentTemplateIndex = null;
    }
    previewImageHandler(previewImageURL) {
        if (this.previewImageModalComponent) {
            this.previewImageModalComponent.openModal(previewImageURL);
        }
    }
    submit() {
        if (this.currentTemplateIndex !== null) {
            const templates = this.getCurrentCategoryTemplates();
            const selectedTemplateObject = templates[this.currentTemplateIndex];
            this.templateSelectionHandler.emit(selectedTemplateObject);
            this.closeModal();
            // Track template usage
            this.ajaxService
                .postJsonDataObserveBody(this.urlsService.AWKWARD.NAMING, {
                eventType: this.eventType,
                eventProperties: {
                    data_template_id: selectedTemplateObject.template_id.toString(),
                    data_template_name: selectedTemplateObject.name,
                },
            })
                .subscribe();
        }
    }
    getCurrentCategoryTemplates() {
        if (this.templatesByCategory.length > 0) {
            const { templates } = this.templatesByCategory[this.currentCategoryIndex];
            return templates;
        }
        return [];
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
    }
}
TemplateModalComponent.ɵfac = function TemplateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TemplateModalComponent)(i0.ɵɵdirectiveInject(i1.AjaxService), i0.ɵɵdirectiveInject(i2.UrlsService), i0.ɵɵdirectiveInject(i3.CustomPDFReportService)); };
TemplateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TemplateModalComponent, selectors: [["ycn-template-modal"]], viewQuery: function TemplateModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PreviewImageModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewImageModalComponent = _t.first);
    } }, inputs: { itemType: "itemType" }, outputs: { templateSelectionHandler: "templateSelectionHandler" }, standalone: false, decls: 14, vars: 7, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "tabs-vertical-wrap", "ng-scope"], [1, "tabs", "tabs-vertical"], [1, "nav", "nav-tabs"], ["class", "nav-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "tab-content"], [1, "tab-pane", "active", "overflow-shadow"], [1, "tab-pane-inner", "overflow-shadow-inner"], [1, "report-modules"], ["class", "report-module-container", 4, "ngFor", "ngForOf"], [3, "cancelHandler", "submitHandler", "disableSubmission", "submitButtonText"], [1, "nav-item", 3, "click"], ["href", "javascript:void(0)", 1, "nav-link", "nav-link-multiline", "user-select-none", 3, "ngClass", "textContent"], [1, "report-module-container"], [1, "template-module", "custom-control", "custom-radio"], ["type", "radio", 1, "custom-control-input", 3, "change", "checked", "value"], [1, "template-module-subtitle"], [1, "custom-control-indicator"], [1, "template-module-controls"], ["class", "btn btn-circle btn-transparent btn-preview", 3, "click", 4, "ngIf"], [1, "template-module-header", "user-select-none"], [1, "template-module-title", 3, "textContent"], ["class", "template-module-subtitle", 4, "ngIf"], [1, "template-module-body", "user-select-none", 3, "textContent"], [1, "btn", "btn-circle", "btn-transparent", "btn-preview", 3, "click"], ["ycnIcon", "", 3, "name"]], template: function TemplateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function TemplateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function TemplateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "ul", 5);
        i0.ɵɵtemplate(6, TemplateModalComponent_li_6_Template, 2, 5, "li", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 7)(8, "div", 8)(9, "div", 9)(10, "div", 10);
        i0.ɵɵtemplate(11, TemplateModalComponent_div_11_Template, 11, 7, "div", 11);
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(12, "ycn-simple-modal-footer", 12);
        i0.ɵɵlistener("cancelHandler", function TemplateModalComponent_Template_ycn_simple_modal_footer_cancelHandler_12_listener() { return ctx.closeModal(); })("submitHandler", function TemplateModalComponent_Template_ycn_simple_modal_footer_submitHandler_12_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(13, "ycn-preview-image-modal");
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog modal-no-border")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.templateHeader);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.templatesByCategory);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.currentCategoryTemplates);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disableSubmission", ctx.currentTemplateIndex === null)("submitButtonText", "Next");
    } }, dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent, i8.PreviewImageModalComponent, i9.IconDirective], encapsulation: 2 });
